// ============================================================================
// cabinetRenderer.tsx — ПРИЛОЖЕНИЕ «КАБИНЕТ» (appKind/code 'cabinet').
//
// Точка входа личного кабинета в оболочке «Предприятие». Как и другие
// системные приложения (чат, файлы, поддержка), рендерер регистрируется
// КЛИЕНТОМ: приложение открывается по коду из реестра рендереров
// (getAppRendererByCode) даже без серверного объекта kind='app'. Серверный
// манифест (при наличии) уточняет имя/область.
//
// Состав вкладок — реестр lib/cabinet/tabs.ts. Встроенные вкладки: «Задачи»
// и «Заявки» — реальные списки на существующих RPC (TaskService.ListTasks /
// OrderService.ListOrders) через общий AutoListForm, «Арбитраж» — существующие
// документы базы (маркетплейс: заявки/отклики), «Тестирование» — существующая
// страница тестов и анкет (PollService), «Поддержка» — существующий инбокс
// обращений (SupportService), «Файлы» — существующий файловый менеджер
// (FileService/ExplorerApp), «Избранное» — существующий чат «только я»
// (MessengerService/ChatThread), «Счета/оплаты» — личный счёт (BillingService:
// баланс/операции; PaymentService: пополнение). Новых proto и серверных прав
// не требуется.
// ============================================================================

import { registerAppRenderer, type AppManifest, APPSDK_VERSION } from '@/lib/apps/sdk';
import { CabinetShell } from '@/components/cabinet/CabinetShell';
import { registerBuiltinCabinetTabs } from '@/lib/cabinet/builtinTabs';
import { CABINET_APP_CODE, CABINET_TITLE } from '@/lib/cabinet/tabs';
import { useCabinetTabs } from '@/lib/cabinet/useCabinetTabs';

function CabinetApp() {
  // Живой реестр: вкладки встроенные + зарегистрированные приложениями/поставками.
  const tabs = useCabinetTabs();
  return <CabinetShell tabs={tabs} title={CABINET_TITLE} />;
}

/** Манифест приложения «Кабинет» (AppHost): системное, на весь воркспейс. */
export const CABINET_MANIFEST: AppManifest = {
  code: CABINET_APP_CODE,
  name: CABINET_APP_CODE,
  synonym: CABINET_TITLE,
  appKind: CABINET_APP_CODE,
  area: 'full',
  apiVersion: APPSDK_VERSION,
  permissions: ['data:read', 'events', 'nav', 'notify'],
};

export function registerCabinetApp(): void {
  registerBuiltinCabinetTabs();
  registerAppRenderer({
    appKind: CABINET_APP_CODE,
    code: CABINET_APP_CODE,
    title: CABINET_TITLE,
    Component: CabinetApp,
    manifest: CABINET_MANIFEST,
  });
}
